module.exports = __webpack_public_path__ + "img/emergency_kit_06.8aa58877.jpg";